// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18tIX","footer":"styles_footer__vbSNC"};